<template>
  <div class="container white" style="padding: 48px 0 0 0">
    <v-snackbar top v-model="snackbar" color="green" multi-line timeout="3000">
      Feedback enviado!
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout column class="menu w-100 white">
      <v-card elevation="2" tile>
        <v-layout
          align-center
          justify-space-around
          class="py-2 px-3 colorSelectedBack sizeTop"
        >
          <img
            :src="require(`@/assets/logos/uc_carsharing_branco.png`)"
            alt="pickndrive"
            style="width: auto; height: 39px"
          />
        </v-layout>
      </v-card>
    </v-layout>

    <div class="pl-3 pr-3">
      <div class="pt-6">
        <strong class="info-reservation">Reserva Finalizada</strong>
        <div class="pt-3 extra-info-reservation">
          Este é um resumo de todos os valores cobrados
        </div>
      </div>

      <div class="pt-6">
        <strong>Reserva</strong>
      </div>

      <div class="pt-3 summary-info">
        <div>
          Valor da Reserva: <span> {{ formatValue(request.value) }} </span>
        </div>
        <div>
          Data da Autorização:
          <span> {{ formatDate(request.auth_date) }} </span>
        </div>
        <div>
          Data da Captura: <span> {{ formatDate(request.catch_date) }} </span>
        </div>
        <div>
          Valor Capturado: <span> {{ formatValue(request.catch_value) }} </span>
        </div>
      </div>

      <div v-if="extension.quantity && extension.quantity !== '0'">
        <div class="pt-6">
          <strong>Extensão da Reserva</strong>
        </div>

        <div class="pt-3 summary-info">
          <div>
            Número de extensões realizadas:
            <span> {{ extension.quantity }} </span>
          </div>
          <div>
            Valor Total da Extensão:
            <span> {{ formatValue(extension.value) }} </span>
          </div>
          <div>
            Data da Última Autorização:
            <span> {{ formatDate(extension.auth_date) }} </span>
          </div>
          <div>
            Data da Última Captura:
            <span> {{ formatDate(extension.catch_date) }} </span>
          </div>
          <div>
            Valor Total Capturado:
            <span> {{ formatValue(extension.catch_value) }} </span>
          </div>
        </div>
      </div>

      <div class="pt-6">
        <strong>Caução</strong>
      </div>

      <div class="pt-3 summary-info">
        <div>
          Valor do Caução: <span> {{ formatValue(deposit.value) }} </span>
        </div>
        <div>
          Data Autorização: <span> {{ formatDate(deposit.auth_date) }} </span>
        </div>
        <div>
          Data da Captura: <span> {{ formatDate(deposit.catch_date) }} </span>
        </div>
        <div>
          Valor Capturado:
          <span> {{ formatValue(deposit.catch_value) }} </span>
          <span v-if="deposit.fine_value"
            >(+ multa de {{ formatValue(deposit.fine_value) }})</span
          >
        </div>
        Saldo liberado do caução:
        <span> {{ formatValue(deposit.refound_value) }} </span>
        <span v-if="deposit.catch_value">
          ({{ formatValue(deposit.value) }} -
          {{ formatValue(deposit.catch_value) }})
        </span>
        <div class="summary-info-extra">
          * O saldo liberado refletirá no seu limite de cartão de crédito. O
          tempo médio é de 3 a 5 dias úteis a contar do dia subsequente à data
          da reserva. Ressaltando também que, o prazo pode variar de banco para
          banco (emissor do cartão), podendo demorar menos ou mais tempo.
        </div>
      </div>

      <div v-if="additional.value">
        <div class="pt-6">
          <strong>Adicional</strong>
        </div>

        <div class="pt-3 summary-info">
          <div>
            Cobrança Adicional:
            <span> {{ formatValue(additional.value) }} </span>
          </div>
          <div>
            Data da Autorização:
            <span> {{ formatDate(additional.auth_date) }} </span>
          </div>
          <div>
            Data da Captura:
            <span> {{ formatDate(additional.catch_date) }} </span>
          </div>
          <div>
            Valor Capturado:
            <span>
              {{ additional.catch_value }} (referente ao adicional que supera o
              caução de {{ formatValue(deposit.value) }})
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center w-100 mt-4 pb-16">
      <v-btn
        large
        style="width: 96%"
        class="btnColor mx-0 white--text"
        @click="back()"
      >
        <span>concluir</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import TransactionController from '../../controllers/TransactionController';
import DateHelper from '../../helpers/DateHelper';
import NumberHelper from '../../helpers/NumberHelper';

export default {
  created() {
    this.vehicleRequestId = this.$route.params.id;
    this.getTransactionsReports();
    this.getExtensionsReport();
    this.snackbar = true;
  },

  data() {
    return {
      transactionController: new TransactionController(this.$resource),
      vehicleRequestId: null,
      snackbar: null,

      request: {
        value: null,
        auth_date: null,
        catch_date: null,
        catch_value: null,
      },

      extension: {
        quantity: null,
        value: null,
        auth_date: null,
        catch_date: null,
        catch_value: null,
      },

      deposit: {
        value: null,
        auth_date: null,
        catch_date: null,
        catch_value: null,
        fine_value: null,
        refound_value: null,
      },

      additional: {
        value: null,
        auth_date: null,
        catch_date: null,
        catch_value: null,
      },
    };
  },

  methods: {
    async getTransactionsReports() {
      try {
        const data = await this.transactionController.getTransactionsByVehicleRequestId(
          this.vehicleRequestId
        );

        data.forEach(transaction => {
          if (transaction.type === 'reservation') {
            this.request.catch_value = transaction.total_value_charged;
            this.request.value = transaction.valor_pre_autorizado;
            this.request.catch_date = transaction.updated_at;
            this.request.auth_date = transaction.pre_authorization_date;
          } else if (transaction.type === 'pre_authorized') {
            this.deposit.value = transaction.valor_pre_autorizado;
            this.deposit.auth_date = transaction.pre_authorization_date;
            this.deposit.catch_date = transaction.updated_at;
            this.deposit.catch_value = transaction.total_value_charged;
            this.deposit.fine_value = transaction.infraction_value;
            this.deposit.refound_value =
              this.deposit.value - this.deposit.catch_value;
          } else if (transaction.type === 'surplus_check_out') {
            this.additional.catch_value = transaction.total_value_charged;
            this.additional.value = transaction.valor_pre_autorizado;
            this.additional.catch_date = transaction.updated_at;
            this.additional.auth_date = transaction.pre_authorization_date;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },

    async getExtensionsReport() {
      try {
        const response = await this.transactionController.getExtensionsByVehicleRequestId(
          this.vehicleRequestId
        );

        this.extension.catch_value = response[0].total_value_charged;
        this.extension.catch_date = response[0].updated_at;
        this.extension.value = response[0].valor_pre_autorizado;
        this.extension.auth_date = response[0].pre_authorization_date;
        this.extension.quantity = response[0].number_of_extensions;
      } catch (error) {
        console.error(error);
      }
    },

    back() {
      this.$router.push({ name: 'driver-vehicle-request-dashboard' });
    },

    formatValue(value) {
      return NumberHelper.formatPrice(value);
    },

    formatDateTime(date) {
      if (date === null) return;
      return DateHelper.formatDatetime(date);
    },

    formatDate(date) {
      if (date === null) return;
      return DateHelper.formatDate(date);
    },
  },
};
</script>

<style lang="scss">
.summary-info-extra {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
}

.summary-info {
  span {
    font-weight: 500;
  }
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.colorSelectedBack {
  background-color: var(--secondary-color) !important;
}

.container {
  position: relative;
  height: 100vh;
  background: #fcfcfc;
}

.info-reservation {
  font-size: 20px;
}

.extra-info-reservation {
  font-size: 18px;
}

.btnColor {
  background-color: var(--primary-color) !important;
}
</style>
